import mixpanel, { Dict } from 'mixpanel-browser';

const getThirdPathSegment = (path: string): string | undefined => {
  const segments = path.split('/').filter(Boolean);
  return segments[2];
};

export default {
  init: (mixpanelToken: string | undefined) => {
    // different tokens for prod and staging to be present on the server
    mixpanel.init(mixpanelToken as string, {
      debug: process.env.NODE_ENV !== 'production',
    });
    console.log(
      '%cMixpanel Initialized',
      'font-size: 1em; padding: 0.25em 1em; margin: 0.25em 0; color: white; background-color: #26ac75; border-radius: 6px;'
    );
  },
  track: (event_name: string, data?: Dict) => {
    mixpanel.track(event_name, data);
  },
  identify: (user_profile: string) => {
    mixpanel.identify(user_profile);
  },
  set_once: (user_data: object) => {
    mixpanel?.people?.set_once(user_data);
  },
  set: (user_data: object) => {
    mixpanel?.people?.set(user_data);
  },
  reset: () => {
    mixpanel.reset();
  },
  register: (props: object) => {
    mixpanel.register(props);
  },
  trackPageView: (path: string) => {
    const screenId = getThirdPathSegment(path);
    const eventName = screenId ? `Page View /${screenId}` : 'Page View';
    mixpanel.track(eventName, { path });
  },
};
